@if (shipment) {
  <div class="buttons">
    @if (shipment.scanViewId && (isUserInternal$ | async) && !isArchived) {
      <a [href]="scanViewUrl" class="buttons__scanview" target="_blank" mat-stroked-button>See in ScanView</a>
    }
    @if (shipment.scanBookId && !isArchived) {
      <a [href]="scanBookUrl" class="buttons__scanbook" target="_blank" mat-stroked-button>See in ScanBook</a>
    }

    @if (openedFrom !== 'Overview') {
      <button mat-stroked-button (click)="openMap()">See on map</button>
    }
  </div>
}
